const removeEmptyStringValues = (data: any, excludeKeys?: { [key: string]: boolean }): any => {
    const newData = { ...data };
    return Object.fromEntries(Object.entries(newData).filter(([i, v]) => excludeKeys?.[i] || v !== ''));
};

export default removeEmptyStringValues;
